module.exports = __webpack_public_path__ + "static/media/why_chart3.c19ea429.png";